/**
 * MobileCategoryTag component using Tailwind CSS.
 * Migrated from styled-components (Jan 2025).
 */

import { Show, useContext } from 'solid-js';
import type { JSX } from 'solid-js';
import theme from '../../../style/theme';
import { Text } from '../../../ui-components/text/text';
import { CrossIcon } from '../../icons-library/cross';
import { AppContext } from '../../../app-context-provider/app-context-provider';

/**
 * CategoryTagListItem - List item wrapper for category tags
 */
const CategoryTagListItem = (props: { children: JSX.Element }) => {
    return (
        <li class="mr-8 last:mr-0">
            {props.children}
        </li>
    );
};

/**
 * CategoryTag - Button styled as a tag/chip
 */
const CategoryTag = (props: {
    children: JSX.Element;
    onClick: (e: any) => void;
    ariaLabel?: string;
}) => {
    return (
        <button
            class="flex items-center border border-gray rounded-xsmall px-2 py-[0.2rem] pb-[0.2rem]! my-3"
            onClick={props.onClick}
            aria-label={props.ariaLabel}
        >
            {props.children}
        </button>
    );
};

/**
 * IconContainer - Container for the close/cross icon
 */
const IconContainer = (props: { children: JSX.Element }) => {
    return (
        <div class="ml-2 mb-[0.1rem] flex justify-center items-center">
            {props.children}
        </div>
    );
};

type CategoryLike = {
    name?: string;
    slug?: string;
};

type MobileCategoryTagProps = {
    onClick: (e: any) => void;
    category: CategoryLike | string | undefined;
};

export const MobileCategoryTag = (props: MobileCategoryTagProps) => {
    const { localize } = useContext(AppContext);

    const getCategoryName = () => {
        if (!props.category) return undefined;
        if (typeof props.category === 'string') return props.category;
        return props.category.name;
    };

    return (
        <Show when={getCategoryName()}>
            <CategoryTagListItem>
                <CategoryTag
                    onClick={props.onClick}
                    ariaLabel={localize('category', 'Category')}
                >
                    <Text color={'gray'} noBlockSpacing={true} fontSize="small">
                        {getCategoryName()}
                    </Text>
                    <IconContainer>
                        <CrossIcon width={1} height={1} fill={theme.palette.gray} ariaLabel={localize('remove', 'Remove')} />
                    </IconContainer>
                </CategoryTag>
            </CategoryTagListItem>
        </Show>
    );
};
